<template>
	<div
		class="component-navigator-bar flex flex-nowrap text-sm bmsm:bm-gx-6 bmmd:bm-gx-6 bmxl:bm-gx-6 ibm-font"
		:class="[
			navigatorBarConfig.theme,
			navigatorBarConfig.size,
			{
				immersive: navigatorBarConfig.offset > 0,
				[immersiveTheme]: immersive,
			},
		]"
		:style="{
			backgroundColor: backgroundColor,
			color: textColor,
		}"
	>
		<!-- 为了表达快速响应的头部，也没有加入动效 -->
		<!-- 为了解决下拉菜单从上向下出现的时的错误问题，动效从底向上 -->
		<!-- 防止logo出现闪现，使用svg内嵌方式 -->
		<div class="flex flex-row flex-nowrap">
			<nuxt-link-enhance
				class="bm-col pr-9 flex items-center"
				:project="project"
				:to="project === PROJECT_MAP_OBJ.DERIVATIVES ? '/futures' : '/'"
				exact
			>
				<svg
					class="logo-futures"
					v-if="project === PROJECT_MAP_OBJ.DERIVATIVES && logoTheme === 'light'"
					width="1844"
					height="274"
					viewBox="0 0 1844 274"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M1156.72 214.975V101.646H1227.49V117.881H1175.04V149.366H1221.62V165.601H1175.04V214.975H1156.68H1156.72Z"
						fill="white"
					/>
					<path
						d="M1266.66 101.646V169.462C1266.66 188.613 1273.32 198.543 1291.01 198.543C1308.7 198.543 1315.36 188.653 1315.36 169.462V101.646H1333.37V166.547C1333.37 199.686 1322.02 214.936 1291.01 214.936C1260 214.936 1248.65 199.686 1248.65 166.547V101.646H1266.66Z"
						fill="white"
					/>
					<path d="M1384.36 117.881H1350.59V101.646H1436.49V117.881H1402.72V214.975H1384.36V117.881Z" fill="white" />
					<path
						d="M1471.68 101.646V169.462C1471.68 188.613 1478.34 198.543 1496.03 198.543C1513.73 198.543 1520.38 188.653 1520.38 169.462V101.646H1538.39V166.547C1538.39 199.686 1527.04 214.936 1496.03 214.936C1465.02 214.936 1453.67 199.686 1453.67 166.547V101.646H1471.68Z"
						fill="white"
					/>
					<path
						d="M1584.06 214.975H1565.7V101.646H1614.56C1634.86 101.646 1647.35 114.808 1647.35 135.732C1647.35 151.809 1639.7 163 1625.28 167.216L1649.79 214.936H1629.34L1606.6 169.147H1584.02V214.936L1584.06 214.975ZM1613.3 153.779C1622.56 153.779 1628.08 148.735 1628.08 139.672V131.87C1628.08 122.768 1622.56 117.763 1613.3 117.763H1584.06V153.819H1613.3V153.779Z"
						fill="white"
					/>
					<path
						d="M1672.05 214.975V101.646H1744.64V117.881H1690.42V149.366H1739.59V165.601H1690.42V198.701H1744.64V214.936H1672.05V214.975Z"
						fill="white"
					/>
					<path
						d="M1760.83 196.533L1773.48 185.067C1781.44 194.484 1790.86 199.371 1803.19 199.371C1817.66 199.371 1825.1 192.475 1825.1 181.954C1825.1 173.481 1820.57 168.595 1807.41 166.073L1797.36 164.339C1775.45 160.399 1764.22 150.508 1764.22 133.091C1764.22 113.625 1779.83 101.686 1803.82 101.686C1820.89 101.686 1833.38 107.636 1842.13 118.472L1829.32 129.466C1823.49 122.097 1815.37 117.369 1802.84 117.369C1790.31 117.369 1782.39 122.57 1782.39 132.146C1782.39 141.721 1788.22 145.189 1800.4 147.553L1810.45 149.602C1833.02 153.858 1843.23 163.591 1843.23 181.008C1843.23 201.42 1828.14 215.093 1802.17 215.093C1783.18 215.093 1770.17 207.882 1760.76 196.573L1760.83 196.533Z"
						fill="white"
					/>
					<path
						d="M365.228 58.6162C380.556 58.6162 392.338 62.1233 401.086 69.5314C409.401 76.5455 413.538 85.9239 413.538 97.9818C413.538 106.73 411.332 114.177 406.958 120.285C402.584 125.959 396.673 130.333 388.792 133.21C399.077 135.18 406.958 139.318 412.199 145.662C417.439 152.006 420.08 160.518 420.08 171.039C420.08 186.801 414.602 198.149 403.884 205.597C394.703 211.705 381.778 214.778 365.188 214.778H293.905V58.6162H365.188H365.228ZM317.784 124.895H358.884C369.838 124.895 377.68 122.925 382.527 119.221C387.334 115.281 389.738 109.173 389.738 100.858C389.738 92.9774 387.334 87.3031 382.527 83.796C377.719 80.0919 369.838 78.3187 359.356 78.3187H317.784V124.895ZM317.784 195.115H361.957C372.005 195.115 379.886 193.381 385.6 190.308C392.575 186.17 396.318 179.59 396.318 170.645C396.318 161.7 393.481 154.686 388.004 150.509C382.527 146.371 374.015 144.401 362.627 144.401H317.784V195.154V195.115Z"
						fill="white"
					/>
					<path
						d="M468.548 101.724V214.816H445.377V101.724H468.548ZM468.548 81.8244H445.377V58.6543H468.548V81.8244Z"
						fill="white"
					/>
					<path
						d="M919.931 214.777V101.685H943.062V126.313C947.278 113.624 959.967 101.685 980.615 101.685H988.338V124.815H976.871C955.474 124.815 943.062 133.287 943.062 145.976V214.777H919.931Z"
						fill="white"
					/>
					<path
						d="M884.034 111.104C876.153 102.79 863.898 98.6523 847.308 98.6523C833.319 98.6523 821.931 101.056 813.617 106.297C804.002 111.971 797.855 121.192 795.451 133.408L818.424 135.378C819.725 129.034 822.995 124.463 828.276 121.389C832.649 118.749 838.56 117.449 845.771 117.449C862.834 117.449 871.345 125.33 871.345 141.052V142.549H836.157C819.922 142.549 807.154 148.106 798.17 159.533C793.087 165.956 790.959 172.852 790.959 180.063C790.959 199.253 807.627 214.779 828.197 214.779C830.246 214.779 836.038 214.542 839.269 214.109C840.57 213.951 841.673 213.715 842.658 213.439C847.623 212.533 852.313 211.232 856.45 209.302C862.243 206.425 867.011 202.366 871.109 197.559V214.779H894.318V142.589C894.318 128.797 890.811 118.315 884.034 111.104ZM871.109 168.045C870.557 175.886 867.05 185.737 860.627 191.136C853.652 197.047 845.298 197.007 835.487 197.007C829.576 197.007 824.768 195.47 821.261 192.633C817.557 189.796 815.784 186.289 815.784 181.915C815.784 168.833 825.084 161.582 843.565 160.321H871.109V168.045Z"
						fill="white"
					/>
					<path
						d="M737.132 58.6162L677.63 189.323L618.089 58.6162H591.333V214.778H614.504V101.725L666.006 214.778H689.215L740.836 101.449V214.778H764.006V58.6162H737.132Z"
						fill="white"
					/>
					<path
						d="M1052.29 195.078V124.818H1078.02V101.688H1052.29V70.2031H1029.16V101.688H1008.24V124.818H1029.16V190.31C1029.16 205.283 1037.63 214.741 1053.59 214.741H1078.02V195.038H1052.29V195.078Z"
						fill="white"
					/>
					<path
						d="M538.688 195.078V124.818H564.42V101.688H538.688V70.2031H515.558V101.688H494.634V124.818H515.558V190.31C515.558 205.283 524.03 214.741 539.989 214.741H564.42V195.038H538.688V195.078Z"
						fill="white"
					/>
					<path d="M147.436 196.296H63.3462V203.665H147.436V196.296Z" fill="white" />
					<path d="M84.3492 242.046H21.3013V249.415H84.3492V242.046Z" fill="white" />
					<path d="M42.2644 196.377H0.298096V203.746H42.2644V196.377Z" fill="white" />
					<path d="M147.437 175.097H84.3494V182.465H147.437V175.097Z" fill="white" />
					<path d="M63.2677 175.097H21.3408V182.465H63.2677V175.097Z" fill="white" />
					<path d="M147.436 80.1318H42.3035V87.5006H147.436V80.1318Z" fill="white" />
					<path d="M63.3071 55.7002H21.3408V63.0689H63.3071V55.7002Z" fill="white" />
					<path
						d="M203.155 126.313C203.155 126.313 203.234 126.195 203.273 126.116C214.464 106.611 217.341 83.9134 211.47 62.2012C205.559 40.4891 191.57 22.4022 172.065 11.2112C159.337 3.92126 144.875 0.0595703 130.295 0.0595703H42.3435V10.5807H130.295H130.611C142.944 10.6201 155.436 13.7725 166.903 20.3137C196.693 37.3761 210.012 72.0525 201.303 103.695C203.746 93.41 203.589 82.6524 200.752 72.1707C196.259 55.5812 185.541 41.75 170.646 33.1992C160.913 27.6431 149.88 24.6877 138.768 24.6877H63.3858V35.2088H138.846C147.87 35.2088 157.012 37.5337 165.445 42.3411C187.866 55.1872 197.481 81.7067 189.915 105.35C194.604 87.381 186.999 67.7573 170.134 58.1031C163.79 54.4779 156.579 52.547 149.289 52.5076H84.3886V63.0287H149.289C154.608 63.0287 159.967 64.3685 164.932 67.2057C180.064 75.8748 185.344 95.1044 176.754 110.275C167.612 106.847 157.682 104.956 147.358 104.956H63.4252V115.477H147.515C183.413 115.556 213.282 141.326 219.705 175.372C213.282 147.355 188.181 126.392 158.234 126.392H42.3435V136.913H158.391C184.753 136.992 206.544 156.497 210.248 181.874C206.662 162.329 189.482 147.434 168.912 147.434H42.4223V157.955H168.912C186.329 157.955 200.436 172.062 200.436 189.479C200.436 206.896 186.329 221.003 168.912 221.003H21.3013V231.524H168.834C189.403 231.524 206.583 216.629 210.169 197.085C206.465 222.501 184.596 242.046 158.155 242.046H105.352V252.567H158.155C186.92 252.567 211.273 233.179 218.799 206.778C210.918 238.933 181.955 262.812 147.397 262.851H42.3829V273.373H147.24C193.659 273.373 231.409 235.623 231.409 189.204C231.409 164.221 220.454 141.76 203.116 126.313H203.155Z"
						fill="white"
					/>
				</svg>

				<svg
					class="logo-futures"
					v-if="project === PROJECT_MAP_OBJ.DERIVATIVES && logoTheme !== 'light'"
					width="1844"
					height="274"
					viewBox="0 0 1844 274"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M1156.72 214.975V101.646H1227.49V117.881H1175.04V149.366H1221.62V165.601H1175.04V214.975H1156.68H1156.72Z"
						fill="#18181D"
					/>
					<path
						d="M1266.66 101.646V169.462C1266.66 188.613 1273.31 198.543 1291.01 198.543C1308.7 198.543 1315.36 188.653 1315.36 169.462V101.646H1333.37V166.547C1333.37 199.686 1322.02 214.936 1291.01 214.936C1260 214.936 1248.65 199.686 1248.65 166.547V101.646H1266.66Z"
						fill="#18181D"
					/>
					<path d="M1384.36 117.881H1350.59V101.646H1436.49V117.881H1402.72V214.975H1384.36V117.881Z" fill="#18181D" />
					<path
						d="M1471.68 101.646V169.462C1471.68 188.613 1478.34 198.543 1496.03 198.543C1513.72 198.543 1520.38 188.653 1520.38 169.462V101.646H1538.39V166.547C1538.39 199.686 1527.04 214.936 1496.03 214.936C1465.02 214.936 1453.67 199.686 1453.67 166.547V101.646H1471.68Z"
						fill="#18181D"
					/>
					<path
						d="M1584.06 214.975H1565.7V101.646H1614.56C1634.86 101.646 1647.35 114.808 1647.35 135.732C1647.35 151.809 1639.7 163 1625.28 167.216L1649.79 214.936H1629.34L1606.6 169.147H1584.02V214.936L1584.06 214.975ZM1613.3 153.779C1622.56 153.779 1628.08 148.735 1628.08 139.672V131.87C1628.08 122.768 1622.56 117.763 1613.3 117.763H1584.06V153.819H1613.3V153.779Z"
						fill="#18181D"
					/>
					<path
						d="M1672.05 214.975V101.646H1744.64V117.881H1690.42V149.366H1739.59V165.601H1690.42V198.701H1744.64V214.936H1672.05V214.975Z"
						fill="#18181D"
					/>
					<path
						d="M1760.83 196.533L1773.48 185.067C1781.44 194.484 1790.86 199.371 1803.19 199.371C1817.66 199.371 1825.1 192.475 1825.1 181.954C1825.1 173.481 1820.57 168.595 1807.41 166.073L1797.36 164.339C1775.45 160.399 1764.22 150.508 1764.22 133.091C1764.22 113.625 1779.83 101.686 1803.82 101.686C1820.89 101.686 1833.38 107.636 1842.13 118.472L1829.32 129.466C1823.49 122.097 1815.37 117.369 1802.84 117.369C1790.31 117.369 1782.39 122.57 1782.39 132.146C1782.39 141.721 1788.22 145.189 1800.4 147.553L1810.44 149.602C1833.02 153.858 1843.23 163.591 1843.23 181.008C1843.23 201.42 1828.14 215.093 1802.17 215.093C1783.18 215.093 1770.17 207.882 1760.75 196.573L1760.83 196.533Z"
						fill="#18181D"
					/>
					<path
						d="M365.227 58.6162C380.556 58.6162 392.338 62.1233 401.086 69.5314C409.4 76.5455 413.538 85.9239 413.538 97.9818C413.538 106.73 411.331 114.177 406.957 120.285C402.583 125.959 396.673 130.333 388.792 133.21C399.076 135.18 406.957 139.318 412.198 145.662C417.439 152.006 420.079 160.518 420.079 171.039C420.079 186.801 414.602 198.149 403.884 205.597C394.702 211.705 381.777 214.778 365.188 214.778H293.904V58.6162H365.188H365.227ZM317.784 124.895H358.883C369.838 124.895 377.679 122.925 382.526 119.221C387.334 115.281 389.737 109.173 389.737 100.858C389.737 92.9774 387.334 87.3031 382.526 83.796C377.719 80.0919 369.838 78.3187 359.356 78.3187H317.784V124.895ZM317.784 195.115H361.957C372.005 195.115 379.886 193.381 385.6 190.308C392.574 186.17 396.318 179.59 396.318 170.645C396.318 161.7 393.481 154.686 388.003 150.509C382.526 146.371 374.015 144.401 362.627 144.401H317.784V195.154V195.115Z"
						fill="#18181D"
					/>
					<path
						d="M468.547 101.724V214.816H445.377V101.724H468.547ZM468.547 81.8244H445.377V58.6543H468.547V81.8244Z"
						fill="#18181D"
					/>
					<path
						d="M919.931 214.777V101.685H943.062V126.313C947.278 113.624 959.967 101.685 980.615 101.685H988.338V124.815H976.872C955.475 124.815 943.062 133.287 943.062 145.976V214.777H919.931Z"
						fill="#18181D"
					/>
					<path
						d="M884.033 111.104C876.152 102.79 863.898 98.6523 847.308 98.6523C833.319 98.6523 821.931 101.056 813.617 106.297C804.002 111.971 797.855 121.192 795.451 133.408L818.424 135.378C819.725 129.034 822.995 124.463 828.275 121.389C832.649 118.749 838.56 117.449 845.771 117.449C862.834 117.449 871.345 125.33 871.345 141.052V142.549H836.156C819.922 142.549 807.154 148.106 798.17 159.533C793.087 165.956 790.959 172.852 790.959 180.063C790.959 199.253 807.627 214.779 828.197 214.779C830.246 214.779 836.038 214.542 839.269 214.109C840.57 213.951 841.673 213.715 842.658 213.439C847.623 212.533 852.312 211.232 856.45 209.302C862.242 206.425 867.01 202.366 871.109 197.559V214.779H894.318V142.589C894.318 128.797 890.811 118.315 884.033 111.104ZM871.109 168.045C870.557 175.886 867.05 185.737 860.627 191.136C853.652 197.047 845.298 197.007 835.487 197.007C829.576 197.007 824.768 195.47 821.261 192.633C817.557 189.796 815.784 186.289 815.784 181.915C815.784 168.833 825.084 161.582 843.564 160.321H871.109V168.045Z"
						fill="#18181D"
					/>
					<path
						d="M737.131 58.6162L677.63 189.323L618.089 58.6162H591.333V214.778H614.503V101.725L666.005 214.778H689.215L740.836 101.449V214.778H764.006V58.6162H737.131Z"
						fill="#18181D"
					/>
					<path
						d="M1052.29 195.078V124.818H1078.02V101.688H1052.29V70.2031H1029.16V101.688H1008.24V124.818H1029.16V190.31C1029.16 205.283 1037.63 214.741 1053.59 214.741H1078.02V195.038H1052.29V195.078Z"
						fill="#18181D"
					/>
					<path
						d="M538.688 195.078V124.818H564.419V101.688H538.688V70.2031H515.557V101.688H494.633V124.818H515.557V190.31C515.557 205.283 524.029 214.741 539.988 214.741H564.419V195.038H538.688V195.078Z"
						fill="#18181D"
					/>
					<path d="M147.436 196.296H63.3456V203.665H147.436V196.296Z" fill="#18181D" />
					<path d="M84.3486 242.046H21.3006V249.415H84.3486V242.046Z" fill="#18181D" />
					<path d="M42.264 196.377H0.297668V203.746H42.264V196.377Z" fill="#18181D" />
					<path d="M147.436 175.097H84.3486V182.465H147.436V175.097Z" fill="#18181D" />
					<path d="M63.2669 175.097H21.34V182.465H63.2669V175.097Z" fill="#18181D" />
					<path d="M147.436 80.1318H42.3033V87.5006H147.436V80.1318Z" fill="#18181D" />
					<path d="M63.3063 55.7002H21.34V63.0689H63.3063V55.7002Z" fill="#18181D" />
					<path
						d="M203.155 126.313C203.155 126.313 203.233 126.195 203.273 126.116C214.464 106.611 217.34 83.9134 211.469 62.2012C205.558 40.4891 191.57 22.4022 172.064 11.2112C159.336 3.92126 144.875 0.0595703 130.295 0.0595703H42.3429V10.5807H130.295H130.61C142.944 10.6201 155.435 13.7725 166.902 20.3137C196.692 37.3761 210.011 72.0525 201.303 103.695C203.746 93.41 203.588 82.6524 200.751 72.1707C196.259 55.5812 185.541 41.75 170.645 33.1992C160.912 27.6431 149.879 24.6877 138.767 24.6877H63.3851V35.2088H138.846C147.869 35.2088 157.011 37.5337 165.444 42.3411C187.865 55.1872 197.48 81.7067 189.915 105.35C194.604 87.381 186.999 67.7573 170.133 58.1031C163.789 54.4779 156.578 52.547 149.288 52.5076H84.388V63.0287H149.288C154.608 63.0287 159.967 64.3685 164.932 67.2057C180.063 75.8748 185.344 95.1044 176.753 110.275C167.611 106.847 157.681 104.956 147.357 104.956H63.4245V115.477H147.515C183.413 115.556 213.282 141.326 219.705 175.372C213.282 147.355 188.181 126.392 158.233 126.392H42.3429V136.913H158.391C184.752 136.992 206.543 156.497 210.247 181.874C206.662 162.329 189.481 147.434 168.912 147.434H42.4217V157.955H168.912C186.329 157.955 200.436 172.062 200.436 189.479C200.436 206.896 186.329 221.003 168.912 221.003H21.3006V231.524H168.833C189.402 231.524 206.583 216.629 210.169 197.085C206.465 222.501 184.595 242.046 158.154 242.046H105.351V252.567H158.154C186.92 252.567 211.272 233.179 218.798 206.778C210.917 238.933 181.955 262.812 147.397 262.851H42.3823V273.373H147.239C193.658 273.373 231.408 235.623 231.408 189.204C231.408 164.221 220.453 141.76 203.115 126.313H203.155Z"
						fill="#18181D"
					/>
				</svg>

				<svg
					class="logo"
					v-if="project !== PROJECT_MAP_OBJ.DERIVATIVES && logoTheme !== 'light'"
					width="1050"
					height="267"
					viewBox="0 0 1050 267"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M355.854 57.8755C370.726 57.8755 382.205 61.2678 390.716 68.5068C394.723 71.877 397.9 76.1243 400.001 80.9198C402.102 85.7153 403.07 90.9301 402.832 96.1601C403.061 103.885 400.823 111.481 396.441 117.847C391.916 123.672 385.774 128.034 378.783 130.386C387.65 131.321 395.794 135.702 401.46 142.587C407.126 149.471 409.859 158.306 409.071 167.187C409.071 182.513 403.771 193.568 393.352 200.807C384.406 206.865 371.857 209.893 355.703 209.893H286.342V57.8755H355.854ZM309.664 122.329H349.645C360.276 122.329 367.818 120.391 372.604 116.787C377.389 113.182 379.631 107.003 379.631 98.9164C379.631 90.8294 377.299 85.7409 372.604 82.3183C367.909 78.8957 360.276 77.0178 350.069 77.0178H309.664V122.329ZM309.664 190.6H352.613C360.545 190.941 368.44 189.329 375.602 185.905C378.937 183.987 381.675 181.183 383.514 177.804C385.353 174.426 386.221 170.604 386.022 166.763C386.022 157.828 383.235 151.255 377.935 147.196C372.634 143.138 364.335 141.139 353.25 141.139H309.664V190.6Z"
						fill="#1F2020"
					/>
					<path
						d="M456.321 99.7645V209.712H433.847V99.7645H456.321ZM456.321 80.4101H433.847V57.8755H456.382L456.321 80.4101Z"
						fill="#1F2020"
					/>
					<path
						d="M895.323 209.712V99.7646H917.827V123.723C921.916 111.365 934.244 99.7646 954.173 99.7646H961.715V122.269H950.569C929.761 122.269 917.676 130.477 917.676 142.835V209.712H895.323Z"
						fill="#1F2020"
					/>
					<path
						d="M860.4 108.912C852.747 100.835 840.834 96.7964 824.66 96.7964C811.03 96.7964 799.975 99.1286 791.888 104.217C787.201 107.063 783.192 110.899 780.142 115.456C777.092 120.012 775.074 125.18 774.229 130.598L796.582 132.537C797.069 129.698 798.179 127.002 799.835 124.645C801.49 122.288 803.648 120.328 806.153 118.907C811.384 116.136 817.262 114.818 823.176 115.091C839.774 115.091 848.063 122.744 848.042 138.049V139.533H813.847C798.036 139.533 785.648 144.955 776.895 156.01C772.299 161.644 769.804 168.7 769.837 175.971C769.837 194.628 786.072 209.742 806.184 209.742C808.152 209.742 813.816 209.53 816.936 209.106C818.059 208.951 819.172 208.729 820.268 208.44C824.882 207.667 829.381 206.314 833.655 204.411C839.116 201.595 843.957 197.712 847.891 192.993V209.712H870.456V139.533C870.395 126.146 866.973 115.818 860.4 108.912ZM847.83 164.279C847.285 171.912 843.893 181.483 837.623 186.753C830.839 192.508 822.721 192.478 813.15 192.478C808.195 192.702 803.314 191.204 799.339 188.237C797.67 187.067 796.313 185.505 795.389 183.689C794.465 181.872 794.001 179.856 794.038 177.818C794.038 165.097 803.125 158.04 821.055 156.798H847.83V164.279Z"
						fill="#1F2020"
					/>
					<path
						d="M717.56 57.8755L659.648 184.966L601.767 57.8755H575.719V209.742H598.283V99.7645L648.381 209.742H670.915L721.134 99.5222V209.742H743.699V57.8755H717.56Z"
						fill="#1F2020"
					/>
					<path
						d="M1024.05 190.57V122.269H1049.07V99.7647H1024.05V69.1431H1001.54V99.7647H981.19V122.269H1001.54V185.875C1001.54 200.444 1009.78 209.651 1025.29 209.651H1049.07V190.57H1024.05Z"
						fill="#1F2020"
					/>
					<path
						d="M524.531 190.57V122.269H549.549V99.7647H524.531V69.1431H502.057V99.7647H481.673V122.269H502.057V185.875C502.057 200.444 510.265 209.651 525.803 209.651H549.549V190.57H524.531Z"
						fill="#1F2020"
					/>
					<path d="M144.047 191.872H62.2375V199.02H144.047V191.872Z" fill="#1F2020" />
					<path d="M82.7126 236.335H21.3481V243.484H82.7126V236.335Z" fill="#1F2020" />
					<path d="M41.7322 191.902H0.90332V199.05H41.7322V191.902Z" fill="#1F2020" />
					<path d="M144.047 171.215H82.6824V178.363H144.047V171.215Z" fill="#1F2020" />
					<path d="M62.177 171.215H21.3784V178.363H62.177V171.215Z" fill="#1F2020" />
					<path d="M144.047 78.8047H41.7625V85.9528H144.047V78.8047Z" fill="#1F2020" />
					<path d="M62.177 55.0283H21.3481V62.1764H62.177V55.0283Z" fill="#1F2020" />
					<path
						d="M198.294 123.753V123.571C205.417 111.129 209.151 97.0348 209.122 82.6974C209.093 68.36 205.302 54.2812 198.128 41.8677C190.954 29.4541 180.648 19.1405 168.24 11.9573C155.832 4.77409 141.756 0.972751 127.418 0.933105H41.7626V11.1706H127.661C138.664 11.2142 149.509 13.7919 159.355 18.7038C169.201 23.6158 177.782 30.7298 184.435 39.4942C191.087 48.2585 195.631 58.4375 197.714 69.2416C199.797 80.0457 199.363 91.1845 196.446 101.794C198.583 92.6167 198.622 83.0758 196.56 73.8816C194.498 64.6874 190.388 56.0769 184.537 48.6913C178.686 41.3058 171.243 35.3355 162.764 31.2253C154.286 27.115 144.989 24.9706 135.566 24.9519H62.2376V35.1894H135.657C143.884 35.1922 151.995 37.1356 159.33 40.8618C166.665 44.588 173.018 49.9919 177.872 56.6344C182.726 63.277 185.945 70.971 187.268 79.0913C188.59 87.2117 187.978 95.5294 185.482 103.369C187.087 97.3204 187.285 90.9848 186.062 84.8478C184.839 78.7108 182.226 72.9354 178.425 67.9645C174.624 62.9936 169.735 58.9593 164.133 56.1709C158.53 53.3826 152.364 51.9142 146.106 51.8784H82.5006V62.2067H145.804C151.18 62.2167 156.46 63.635 161.117 66.3204C165.775 69.0058 169.648 72.8645 172.35 77.5123C175.052 82.1601 176.49 87.4347 176.519 92.8109C176.549 98.1871 175.169 103.477 172.518 108.154C163.369 104.752 153.687 103.009 143.926 103.005H62.1468V113.243H143.926C160.607 113.245 176.765 119.067 189.615 129.705C202.464 140.343 211.2 155.13 214.316 171.518C211.207 157.983 203.603 145.9 192.745 137.242C181.886 128.584 168.414 123.861 154.527 123.844H41.7323V133.99H154.678C166.943 134.032 178.785 138.481 188.043 146.527C197.301 154.573 203.357 165.678 205.108 177.818C203.382 168.414 198.416 159.911 191.074 153.786C183.732 147.662 174.477 144.301 164.916 144.289H41.7929V154.526H164.885C173.023 154.526 180.827 157.759 186.581 163.513C192.335 169.267 195.568 177.071 195.568 185.208C195.568 193.346 192.335 201.15 186.581 206.904C180.827 212.658 173.023 215.891 164.885 215.891H21.3481V226.128H164.916C174.477 226.115 183.732 222.755 191.074 216.63C198.416 210.505 203.382 202.003 205.108 192.599C203.334 204.748 197.246 215.852 187.959 223.883C178.672 231.913 166.804 236.333 154.527 236.335H103.036V246.573H154.527C167.864 246.555 180.833 242.198 191.477 234.161C202.121 226.123 209.861 214.842 213.529 202.018C209.696 217.553 200.777 231.358 188.191 241.238C175.606 251.118 160.077 256.503 144.077 256.538H41.8837V266.775H143.926C160.566 266.855 176.836 261.857 190.561 252.448C204.286 243.038 214.814 229.666 220.739 214.116C226.665 198.565 227.705 181.577 223.721 165.42C219.738 149.263 210.92 134.706 198.445 123.692L198.294 123.753Z"
						fill="#1F2020"
					/>
				</svg>

				<svg
					class="logo"
					v-if="project !== PROJECT_MAP_OBJ.DERIVATIVES && logoTheme === 'light'"
					width="1050"
					height="267"
					viewBox="0 0 1050 267"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M355.854 57.876C370.726 57.876 382.205 61.2683 390.716 68.5072C394.722 71.8775 397.899 76.1248 400 80.9203C402.101 85.7158 403.07 90.9306 402.831 96.1606C403.061 103.885 400.822 111.482 396.44 117.847C391.916 123.673 385.774 128.035 378.782 130.387C387.649 131.321 395.793 135.703 401.459 142.587C407.125 149.471 409.859 158.306 409.071 167.187C409.071 182.513 403.77 193.568 393.351 200.807C384.406 206.865 371.856 209.894 355.702 209.894H286.342V57.876H355.854ZM309.664 122.33H349.645C360.276 122.33 367.818 120.391 372.603 116.787C377.389 113.183 379.63 107.004 379.63 98.9169C379.63 90.8299 377.298 85.7414 372.603 82.3188C367.909 78.8962 360.276 77.0183 350.069 77.0183H309.664V122.33ZM309.664 190.6H352.613C360.545 190.942 368.439 189.33 375.602 185.905C378.936 183.987 381.675 181.184 383.514 177.805C385.353 174.426 386.221 170.605 386.021 166.763C386.021 157.828 383.235 151.255 377.934 147.197C372.634 143.138 364.335 141.139 353.249 141.139H309.664V190.6Z"
						fill="white"
					/>
					<path
						d="M456.321 99.765V209.712H433.847V99.765H456.321ZM456.321 80.4106H433.847V57.876H456.381L456.321 80.4106Z"
						fill="white"
					/>
					<path
						d="M895.323 209.712V99.7646H917.827V123.723C921.916 111.365 934.243 99.7646 954.173 99.7646H961.715V122.269H950.569C929.761 122.269 917.676 130.477 917.676 142.835V209.712H895.323Z"
						fill="white"
					/>
					<path
						d="M860.4 108.912C852.747 100.835 840.834 96.7964 824.659 96.7964C811.03 96.7964 799.974 99.1286 791.887 104.217C787.2 107.063 783.192 110.899 780.142 115.456C777.092 120.012 775.074 125.18 774.229 130.598L796.582 132.537C797.068 129.698 798.179 127.002 799.834 124.645C801.49 122.288 803.648 120.328 806.153 118.907C811.384 116.136 817.262 114.818 823.175 115.091C839.773 115.091 848.062 122.744 848.042 138.049V139.533H813.846C798.036 139.533 785.648 144.955 776.895 156.01C772.299 161.644 769.804 168.7 769.837 175.971C769.837 194.628 786.072 209.742 806.183 209.742C808.152 209.742 813.816 209.53 816.936 209.106C818.059 208.951 819.171 208.729 820.268 208.44C824.882 207.667 829.38 206.314 833.655 204.411C839.116 201.595 843.957 197.712 847.891 192.993V209.712H870.456V139.533C870.395 126.146 866.972 115.818 860.4 108.912ZM847.83 164.279C847.285 171.912 843.893 181.483 837.623 186.753C830.838 192.508 822.721 192.478 813.15 192.478C808.194 192.702 803.314 191.204 799.338 188.237C797.669 187.067 796.313 185.505 795.389 183.689C794.465 181.872 794.001 179.856 794.038 177.818C794.038 165.097 803.124 158.04 821.055 156.798H847.83V164.279Z"
						fill="white"
					/>
					<path
						d="M717.559 57.876L659.648 184.967L601.766 57.876H575.718V209.743H598.283V99.765L648.38 209.743H670.915L721.133 99.5227V209.743H743.698V57.876H717.559Z"
						fill="white"
					/>
					<path
						d="M1024.05 190.57V122.269H1049.07V99.7647H1024.05V69.1431H1001.54V99.7647H981.19V122.269H1001.54V185.875C1001.54 200.444 1009.78 209.651 1025.29 209.651H1049.07V190.57H1024.05Z"
						fill="white"
					/>
					<path
						d="M524.531 190.57V122.269H549.549V99.7647H524.531V69.1431H502.057V99.7647H481.672V122.269H502.057V185.875C502.057 200.444 510.265 209.651 525.803 209.651H549.549V190.57H524.531Z"
						fill="white"
					/>
					<path d="M144.047 191.872H62.2373V199.02H144.047V191.872Z" fill="white" />
					<path d="M82.7124 236.335H21.3479V243.484H82.7124V236.335Z" fill="white" />
					<path d="M41.732 191.903H0.903076V199.051H41.732V191.903Z" fill="white" />
					<path d="M144.047 171.215H82.6821V178.363H144.047V171.215Z" fill="white" />
					<path d="M62.1768 171.215H21.3782V178.363H62.1768V171.215Z" fill="white" />
					<path d="M144.046 78.8052H41.7622V85.9533H144.046V78.8052Z" fill="white" />
					<path d="M62.1768 55.0293H21.3479V62.1774H62.1768V55.0293Z" fill="white" />
					<path
						d="M198.293 123.753V123.572C205.417 111.129 209.151 97.0353 209.122 82.6979C209.093 68.3604 205.302 54.2817 198.128 41.8681C190.954 29.4546 180.648 19.141 168.24 11.9578C155.832 4.77458 141.756 0.973239 127.418 0.933594H41.7623V11.1711H127.661C138.664 11.2147 149.509 13.7924 159.354 18.7043C169.2 23.6162 177.782 30.7303 184.435 39.4946C191.087 48.259 195.631 58.438 197.714 69.2421C199.797 80.0462 199.363 91.185 196.446 101.794C198.583 92.6172 198.622 83.0763 196.56 73.8821C194.498 64.6879 190.388 56.0774 184.537 48.6918C178.685 41.3062 171.243 35.336 162.764 31.2257C154.285 27.1155 144.988 24.9711 135.566 24.9524H62.2374V35.1899H135.657C143.884 35.1927 151.995 37.1361 159.33 40.8623C166.665 44.5885 173.018 49.9923 177.872 56.6349C182.726 63.2775 185.945 70.9715 187.267 79.0918C188.589 87.2122 187.978 95.5299 185.481 103.369C187.086 97.3209 187.285 90.9853 186.062 84.8483C184.838 78.7113 182.226 72.9359 178.425 67.965C174.624 62.9941 169.734 58.9598 164.132 56.1714C158.53 53.383 152.364 51.9146 146.106 51.8788H82.5004V62.2072H145.803C151.18 62.2172 156.459 63.6355 161.117 66.3209C165.775 69.0063 169.647 72.865 172.35 77.5128C175.052 82.1606 176.489 87.4352 176.519 92.8114C176.548 98.1876 175.169 103.478 172.518 108.155C163.369 104.753 153.687 103.009 143.925 103.006H62.1465V113.243H143.925C160.607 113.246 176.765 119.068 189.614 129.706C202.464 140.343 211.2 155.131 214.316 171.518C211.207 157.983 203.603 145.901 192.745 137.243C181.886 128.585 168.414 123.862 154.526 123.844H41.7321V133.991H154.678C166.943 134.032 178.785 138.482 188.043 146.527C197.3 154.573 203.357 165.679 205.108 177.818C203.381 168.414 198.416 159.912 191.074 153.787C183.732 147.662 174.477 144.302 164.915 144.289H41.7926V154.527H164.885C173.023 154.527 180.827 157.759 186.581 163.513C192.335 169.267 195.567 177.071 195.567 185.209C195.567 193.346 192.335 201.15 186.581 206.904C180.827 212.658 173.023 215.891 164.885 215.891H21.3479V226.129H164.915C174.477 226.116 183.732 222.756 191.074 216.631C198.416 210.506 203.381 202.003 205.108 192.599C203.333 204.748 197.246 215.853 187.959 223.883C178.671 231.914 166.804 236.334 154.526 236.336H103.036V246.573H154.526C167.864 246.555 180.833 242.199 191.477 234.161C202.12 226.124 209.861 214.842 213.528 202.019C209.696 217.553 200.777 231.359 188.191 241.239C175.606 251.118 160.077 256.504 144.077 256.538H41.8835V266.776H143.925C160.566 266.856 176.835 261.858 190.561 252.448C204.286 243.039 214.814 229.666 220.739 214.116C226.664 198.566 227.705 181.578 223.721 165.421C219.737 149.264 210.919 134.707 198.445 123.693L198.293 123.753Z"
						fill="white"
					/>
				</svg>
			</nuxt-link-enhance>
			<NavigatorBarMenu
				:theme="navigatorBarConfig.theme"
				:size="navigatorBarConfig.size"
				:offset="navigatorBarConfig.offset"
				:inverse="navigatorBarConfig.inverse"
				:project="project"
				:common-routes-config="remixCommonRoutesConfig"
			/>
		</div>
		<NavigatorBarSide
			:theme="navigatorBarConfig.theme"
			:size="navigatorBarConfig.size"
			:offset="navigatorBarConfig.offset"
			:inverse="navigatorBarConfig.inverse"
			:show-theme-switcher="navigatorBarConfig.themeSwitcher"
			:show-setting="showSetting"
			:setting="setting"
			:project="project"
			:common-routes-config="remixCommonRoutesConfig"
			@onSettingChange="handleSettingChange"
		/>
		<TradeSetting
			v-if="!!settingConfig"
			:project="settingConfig.project"
			:setting="settingConfig.setting"
			@onChange="(v) => $emit('change:setting', v)"
		>
			<img :class="$style.Navigator__Icon" src="../../components/TradeNavigator/assets/setting.svg" />
			<template #preference>
				<slot name="preference" />
			</template>
			<template #layoutConfig>
				<slot name="layoutConfig" />
			</template>
		</TradeSetting>
		<!-- @TODO 这里少了对话框，到时候要拿回来 -->
	</div>
</template>

<script>
import _debounce from 'lodash-es/debounce';
import TradeSetting from '../../components/TradeSetting/index.vue';
import commonMixins from './mixins';
import messages from './i18n';

import { NAVIGATOR_BAR_CONFIG_MAP, NAVIGATOR_BAR_CONFIG_DEFAULT, PROJECT_MAP, COMMON_ROUTES_MAP } from './config';
import { FUTURES_NAVIGATOR_BAR_CONFIG_MAP } from './futures-config';
import { getViewConfig, getCustomConfig } from '~/frontend-shared/helper/util';
import NuxtLinkEnhance from './components/NuxtLinkEnhance';
import NavigatorBarMenu from './components/NavigatorBarMenu';
import NavigatorBarSide from './components/NavigatorBarSide';
import { usePatchStore } from '~/common/js/patch';

export default {
	name: 'ComponentNavigatorBar',
	i18n: {
		messages,
	},
	components: {
		NuxtLinkEnhance,
		NavigatorBarMenu,
		NavigatorBarSide,
		TradeSetting,
	},
	mixins: [commonMixins],

	props: {
		// 支持自定义传入皮肤，优先级高于导航里的路由配置
		theme: {
			type: String,
			default: '',
		},
		// 背景色
		backgroundColor: {
			type: String,
			default: undefined,
		},
		// 背景色
		textColor: {
			type: String,
			default: undefined,
		},
		// 支持自定义传入皮肤，优先级高于导航里的路由配置
		size: {
			type: String,
			default: '',
		},
		// 皮肤切换按钮
		// 在路由的配置中可以设置默认的themeSwitcher，但以从父组件中传入的props优先级最高
		showThemeSwitcher: {
			type: Boolean,
			default: null,
		},
		// 设置按钮
		showSetting: {
			type: Boolean,
			default: false,
		},
		setting: {
			type: Object,
		},
		project: {
			type: String,
			default: PROJECT_MAP.MASTER,
		},
		settingConfig: {
			type: Object,
		},
	},
	data() {
		return {
			PROJECT_MAP_OBJ: PROJECT_MAP,
			immersive: false, // 沉浸式导航启动标记
			commonRoutesMap: COMMON_ROUTES_MAP,
			commonRoutesConfig: null,
			commonCopperRoutesConfig: null,
		};
	},

	computed: {
		locale() {
			return this.store.locale;
		},
		isDelegation() {
			return this.store.account.isDelegation;
		},

		// @TODO 改成用class。get的方式获取某一项
		navigatorBarConfig() {
			const barConfig =
				this.project === PROJECT_MAP.DERIVATIVES
					? FUTURES_NAVIGATOR_BAR_CONFIG_MAP.get(this.$route.name)
					: NAVIGATOR_BAR_CONFIG_MAP.get(this.$route.name);
			const config = {
				...NAVIGATOR_BAR_CONFIG_DEFAULT,
				...(barConfig || {}),
			};

			return {
				...config,
				theme: this.theme || config.theme,
				size: this.size || config.size,
				themeSwitcher: typeof this.showThemeSwitcher === 'boolean' ? this.showThemeSwitcher : config.themeSwitcher,
			};
		},
		// offset不存在时，则不进行沉浸式颜色转换
		// 沉浸式颜色转换的前提是offset大于0
		// 浅色 不反转时 沉浸式为浅色
		// ~浅色 反转时 沉浸式为浅色透明
		// 浅色透明 不反转时 沉浸式为浅色
		// ~浅色透明 反转时 沉浸式为深色
		// ~深色 不反转时 沉浸式为深色
		// 深色 反转时 沉浸式为浅色
		// ~深色透明 不反转时 沉浸式为深色
		// 深色透明 反转时 沉浸式为浅色
		immersiveTheme() {
			const { theme, offset } = this.navigatorBarConfig;

			if (!offset) {
				return '';
			}

			if (theme === 'light' || theme === 'light-transparent') {
				return 'immersive-light';
			} else {
				return 'immersive-dark';
			}
		},
		logoTheme() {
			const { theme } = this.navigatorBarConfig;

			if (theme === 'light' || theme === 'light-transparent') {
				return 'dark';
			} else {
				return 'light';
			}
		},
		remixCommonRoutesConfig() {
			const isFuturesV2 = this.futuresVersion === 2;
			// 现货配置
			// 页面是否展示：显示，并且不在语种黑名单中
			// 是否热门，以
			if (this.commonRoutesConfig || this.commonCopperRoutesConfig) {
				let commonRoutesConfig = !this.isDelegation ? this.commonRoutesConfig : this.commonCopperRoutesConfig;

				commonRoutesConfig = commonRoutesConfig
					// v1 暂时不支持跟单
					.filter(item => !isFuturesV2 ? item?.menuKey !== 'FUTURES_COPY' : true)
					.map((item) => {
						if (item.type === 'single') {
							return {
								...item,
								...this.commonRoutesMap.get(item.menuKey),
								hot: item.hot,
								show: item.show && !item?.blackLangList?.includes(this.$$transRouteLocale),
							};
						} else {
							return {
								...item,
								list: item.list
									.map((subItem) => {
										return {
											...subItem,
											...this.commonRoutesMap.get(subItem.menuKey),
											show:
												subItem.show &&
												!this.commonRoutesMap.get(subItem.menuKey)?.blackLangList?.includes(this.$$transRouteLocale),
											tag: subItem.menuKey === 'TRADE.FUTURES_USDT' || subItem.menuKey === 'TRADE.FUTURES_COIN' ? isFuturesV2 ? 'V2.0' : 'V1.0' : false,
										};
									})
									.filter((item) => item),
								hot: item.hot,
								show: item.show && !item?.blackLangList?.includes(this.$$transRouteLocale),
							};
						}
					});

				// 特别处理一下trade，让他能自动拼上当前选择的币种
				commonRoutesConfig.forEach((item) => {
					if (item.value === 'TRADE') {
						item.list = item.list.map((subItem) => {
							if (subItem.value === 'TRADE.ADVANCED') {
								return {
									...subItem,
									show:
										subItem.show &&
										!this.commonRoutesMap.get(subItem.menuKey)?.blackLangList?.includes(this.$$transRouteLocale),
									to: {
										path: subItem.to,
										query: {
											...subItem.to.query,
											...this.$route.query,
											type: null,
										},
									},
								};
							} else if (subItem.value === 'TRADE.MARGIN') {
								return {
									...subItem,
									show:
										subItem.show &&
										!this.commonRoutesMap.get(subItem.menuKey)?.blackLangList?.includes(this.$$transRouteLocale),
									to: {
										path: subItem.to,
										query: {
											...subItem.to.query,
											...this.$route.query,
											type: 'margin',
										},
									},
								};
							} else {
								return subItem;
							}
						});
					}
				});

				// console.log('commonRoutesConfig', commonRoutesConfig);
				return commonRoutesConfig;
			} else {
				return this.$$COMMON_ROUTES_CONFIG;
			}
		},
	},

	methods: {
		// 滚动事件
		// 延迟一帧处理
		// offset=0或者纯色背景时没有效果变化
		handleScroll: _debounce(function () {
			if (this.navigatorBarConfig.offset === 0 || ['light', 'dark'].includes(this.navigatorBarConfig.theme)) {
				this.immersive = false;
				return;
			}

			const scrollTop = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;

			this.immersive = scrollTop > this.navigatorBarConfig.offset;
		}, 16.6),
		handleSettingChange(data) {
			this.$emit('onSettingChange', data);
		},
		getNavigatorConfig() {
			const navigatorConfig = location.hostname === 'beta.bitmart.com' ? 'navigator_config_beta' : 'navigator_config';
			const navigatorCommonRoutersConfig =
				location.hostname === 'beta.bitmart.com'
					? 'navigator_common_routes_config_beta'
					: 'navigator_common_routes_config';

			const navigatorCommonCopperRoutersConfig =
				location.hostname === 'beta.bitmart.com'
					? 'navigator_common_copper_routes_config_beta'
					: 'navigator_common_copper_routes_config';

			Promise.all([
				getViewConfig(navigatorConfig),
				getViewConfig(navigatorCommonRoutersConfig),
				getViewConfig(navigatorCommonCopperRoutersConfig),
				getCustomConfig('navigator_config_parent'),
			]).then(
				([
					navigatorConfigResData,
					navigatorCommonRoutesConfigResData,
					navigatorCommonCopperRoutesConfigResData,
					navigatorConfigParentResData,
				]) => {
					// 配置项是否已开启
					if (!navigatorCommonRoutesConfigResData?.enable || !navigatorCommonCopperRoutesConfigResData?.enable) return;

					// 先合入本地配置
					const commonRoutesMap = new Map([...this.commonRoutesMap]);

					// 原配置项是否启用，逐个关闭逻辑并移除
					if (navigatorConfigResData?.enable) {
						navigatorConfigResData?.list?.forEach((item) => {
							commonRoutesMap.set(item.value, item);
						});
					}

					// navigatorConfigParentResData优先级更高
					Object.keys(navigatorConfigParentResData || {}).forEach((key) => {
						const item = navigatorConfigParentResData[key];
						item?.value && commonRoutesMap.set(item.value, item);
					});

					// 只作为扩展集，不覆盖原来的commonRoutesMap
					// 同名Key配置会进行覆盖
					this.commonRoutesMap = commonRoutesMap;
					this.commonRoutesConfig = navigatorCommonRoutesConfigResData?.list;
					this.commonCopperRoutesConfig = navigatorCommonCopperRoutesConfigResData?.list;
				}
			);
		},
	},

	mounted() {
		// console.log('this.$route.name', this.$route.name);
		// 加载导航处专用字体
		import('./assets/iconfont');

		this.getNavigatorConfig();

		this.$nextTick(() => {
			this.immersive = false;
			window.removeEventListener('scroll', this.handleScroll, false);
			window.addEventListener('scroll', this.handleScroll, false);
		}, 0);

		// this.$nextTick(() => {

		// });
	},
	setup() {
		const { store } = usePatchStore();
		const futuresVersion = useCookie('futuresVersion', {
			default: () => 2,
		});
		return {
			store,
			futuresVersion,
		};
	},
};
</script>

<style lang="less">
html,
html.day-mode {
	--color-navigator-text: #1a1b1f;
	--color-navigator-bg: #ffffff;
	--color-navigator-line: #f3f8fa;
	--navigator-divider-width: 1px;
}

.night-mode {
	--color-navigator-text: #ffffff;
	--color-navigator-bg: #000000;
	--color-navigator-line: transparent;
}
</style>
<style lang="less">
@import './assets/css/tailwind-navigator.less';
</style>

<style lang="less" scoped>
@import './assets/css/ui.variables.less';

// 换成css变量的形式（使颜色变化更加自然），但也保留了老的变量颜色

.component-navigator-bar {
	position: relative;
	color: var(--color-navigator-text);
	background-color: var(--color-navigator-bg);
	box-sizing: border-box;
	height: @navigator_bar_height;
	padding-right: var(--bm-gutter-x, 5%);
	padding-left: var(--bm-gutter-x, 5%);

	&::after {
		content: '';
		display: block;
		position: absolute;
		bottom: -1px;
		left: 0;
		right: 0;
		border-bottom: var(--navigator-divider-width) solid var(--color-navigator-line);
	}

	&.small {
		height: @navigator_bar_height_small;
	}
	&.medium {
		height: @navigator_bar_height_medium;
	}

	// 通透模式

	&.light-transparent {
		color: @black_color;
		background-color: transparent;
	}

	&.dark-transparent {
		color: @white_color;
		background-color: transparent;
	}

	&.light {
		color: @black_color;
		background-color: @white_color;
		--navigator-icon-filter: none;
	}

	&.dark {
		color: @white_color;
		background-color: @black_color;
		--navigator-icon-filter: invert(1);
	}

	&.immersive {
		transition: color 0.3s ease, height 0.3s ease, background-color 0.3s ease;
		&:after {
			border-bottom: 1px solid transparent;
		}
	}

	&.immersive-light {
		position: relative;
		color: @black_color;
		background-color: @white_color;
		&:after {
			border-bottom: 1px solid @gray_color_200;
		}
	}

	&.immersive-dark {
		color: @white_color;
		background-color: @black_color;
		&:after {
			border-bottom: 1px solid transparent;
		}
	}

	.logo {
		width: 120px;
		height: 28px;
		object-fit: contain;
	}
	.logo-futures {
		width: 235px;
		height: 28px;
		object-fit: contain;
	}
}

.component-navigator-bar {
	&.text-sm {
		font-size: 0.875rem;
		line-height: 1.25rem;
	}
	&.flex-nowrap {
		flex-wrap: nowrap;
	}
	&.flex {
		display: flex;
	}

	@media (min-width: 1120px) {
		&.bmxl\:bm-gx-6 {
			--bm-gutter-x: 1.5rem;
		}
	}
	@media (min-width: 640px) {
		&.bmmd\:bm-gx-6 {
			--bm-gutter-x: 1.5rem;
		}
	}
	@media (min-width: 480px) {
		&.bmsm\:bm-gx-6 {
			--bm-gutter-x: 1.5rem;
		}
	}
}

</style>

<style lang="less" module>
.Navigator {
	&__IconButton {
		margin-left: 28px;
		padding: 0;
		height: 56px;
		background: none;
		border: 0 none;
		cursor: pointer;
		&:focus-visible {
			outline: 0 none;
		}
	}
	&__Icon {
		margin-left: 24px;
		width: 20px;
		height: 20px;
		cursor: pointer;
		filter: var(--navigator-icon-filter);
		vertical-align: middle;
		&--theme {
			transform: scale(0.85);
		}
	}
}
</style>
